import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import QuizPresenter from 'presenters/QuizPresenter';

import useStyles from './useStyles';

const DesktopQuiz = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { mortgagePayment, houseValueDp, houseValue } = props;
  const readableMortgagePayment = QuizPresenter.formattedMoney(mortgagePayment.toFixed(0));
  const readableHouseDp = QuizPresenter.formattedMoney(houseValueDp.toFixed(0));
  const readableHouseValue = QuizPresenter.formattedMoney(houseValue.toFixed(0));

  return (
    <Box className={classes.paper}>
      <Box className={classes.item}>
        <Typography variant="subtitle1" color="secondary" className={classes.itemLabel}>
          {t('components.Quiz.IntermediateResults.mortgagePayment')}
        </Typography>
        <Typography className={classes.value} variant="h1">
          {readableMortgagePayment}
        </Typography>
      </Box>
      <Box className={classes.item}>
        <Typography variant="subtitle1" color="secondary" className={classes.itemLabel}>
          {t('components.Quiz.IntermediateResults.downPayment')}
        </Typography>
        <Typography className={classes.value} variant="h1">
          {readableHouseDp}
        </Typography>
      </Box>
      <Box className={classes.item}>
        <Typography variant="subtitle1" color="secondary" className={classes.itemLabel}>
          {t('components.Quiz.IntermediateResults.homePrice')}
        </Typography>
        <Typography className={classes.value} variant="h1">
          {readableHouseValue}
        </Typography>
      </Box>
    </Box>
  );
};

DesktopQuiz.propTypes = {
  mortgagePayment: PropTypes.number.isRequired,
  houseValueDp: PropTypes.number.isRequired,
  houseValue: PropTypes.number.isRequired,
};

export default DesktopQuiz;



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/IntermediateResults/IntermediateResults.js